import CircularProgress from '@mui/material/CircularProgress'
import { Alert, Box } from '@mui/material'

import { PowerBiReportRenderer } from '~components/power-bi-report-renderer'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import { powerBiPoolFilterDefaults } from '../../../../constants/power-bi'
import { ReportWithToken } from '../../../../hooks/queries/reports/use-power-bi-report-with-token'

export function EuEtsReport({
  selectedReport,
}: {
  selectedReport: ReportWithToken
}) {
  const { data, isLoading, isError } = useGetMe()

  if (isLoading) {
    return <CircularProgress aria-label="Loading…" />
  }

  if (isError) {
    return (
      <Box sx={{ m: 3 }}>
        <Alert severity="error">
          Oops! There was an error getting your user. Please reload the page or
          try again later.
        </Alert>
      </Box>
    )
  }

  const reportFilters = {
    ...powerBiPoolFilterDefaults,
    target: {
      // all data are shown for staff
      column: data?.isInternal ? '' : 'PartnerKey',
      table: data?.isInternal ? '' : 'factView_EUETS VoyageCarbon',
    },
  }

  return (
    <PowerBiReportRenderer
      defaultFilters={reportFilters}
      report={selectedReport}
      customValue={
        data?.poolPartnerKeys && data?.poolPartnerKeys.length > 0
          ? data?.poolPartnerKeys[0]
          : undefined
      }
    />
  )
}
